import { GenericCardCarousel as GenericCardCarouselComponent } from 'components/GenericCardCarousel';
import type {
  GenericPage,
  GenericCardCarouseComponent as TGenericCardCarouseComponent,
} from 'server/repository/hygraph/generated/graphqlTypes';
import type { ReferencedProduct } from 'server/model/marketplace/product/referencedProductModel';
import type { DictionaryItem } from 'service/dictionary/dictionaryService';
import type { ISharedTemplateProps } from 'templates/TemplateMapper/types';

type TDataItem = GenericPage | ReferencedProduct;

interface IGenericCardCarousel {
  templateProps: TGenericCardCarouseComponent & {
    products?: ReferencedProduct[];
    readMoreText: DictionaryItem;
  };
}

export const GenericCardCarousel = (
  props: IGenericCardCarousel &
    ISharedTemplateProps & {
      data?: TDataItem[];
    },
) => {
  const {
    data,
    templateProps: {
      articles,
      products,
      cardVariation,
      extension,
      dictionaryItem,
      heading,
      subHeading,
      pointCtaToArticlesList,
      readMoreText,
    },
    difficultyCopy,
    templateIndex,
    primarySubBrandColor,
  } = props;
  return (
    <GenericCardCarouselComponent
      data={data}
      articles={articles}
      products={products}
      cardVariation={cardVariation}
      extension={extension}
      dictionaryItem={dictionaryItem}
      heading={heading}
      subHeading={subHeading}
      pointCtaToArticlesList={pointCtaToArticlesList}
      difficultyCopy={difficultyCopy}
      templateIndex={templateIndex}
      primarySubBrandColor={primarySubBrandColor}
      readMoreText={readMoreText}
    />
  );
};
